// extracted by mini-css-extract-plugin
export default {"modal_wrapper":"Modal_modal_wrapper__nTdlG","modal_inner":"Modal_modal_inner__bUh3F","close_button":"Modal_close_button__4xTF9"};